import {AudioController} from '../../views/library/player/audio'
import {shuffle, trackListEquals, shuffled} from '../../common/util'

const mediaSession = navigator.mediaSession
const audio = new AudioController()

// 让audio控制器全局可访问，便于DLNA模式切换
window.audioController = audio

async function persistQueue(state, vm) { 
    // 如果播放队列为空，直接返回
    if (!state.queue || state.queue.length === 0) {
        return
    }
    
    try {
        // 获取当前播放歌曲ID
        let currentTrackId = null
        if (state.queueIndex >= 0 && state.queueIndex < state.queue.length) {
            const currentTrack = state.queue[state.queueIndex]
            if (currentTrack && currentTrack.id) {
                currentTrackId = currentTrack.id
            }
        }
        
        // 当前播放位置（秒）
        const position = (state.currentTime || 0)
        
        // 使用统一的API接口保存播放队列, 单位毫秒
        await vm.$api.subsonic.savePlayQueue(state.queue, currentTrackId, position)
        
    } catch (error) {
        console.warn('保存播放队列到服务器失败:', error.message)
    }
}
async function clearQueueApi(state, vm) {
    await vm.$api.subsonic.savePlayQueue([], null, 0)
}
const common = {
    state: {
        // fullPath: '/Users/macbookair/Music/my_music/music', // todo test
        fullPath: '/app/media',
        checkedIds: [],
        checkedData: [],
        defaultTableHeight: 800,
        userRole: '',
        username: '',
        remoteVersion: '',
        isSuperuser: false,
        isPlaying: false,
        queue: [],
        queueIndex: -1,
        currentTime: 0,
        duration: 0,
        repeat: localStorage.getItem('player.repeat') !== 'false',
        shuffle: localStorage.getItem('player.shuffle') === 'true',
        hasMsg: false,
        searchTerm: '',
        sortedField: localStorage.getItem('sortedField') ? JSON.parse(localStorage.getItem('sortedField')) : [],
        searchWord: localStorage.getItem('searchWord') || '',
        volume: localStorage.getItem('player.volume') ? parseFloat(localStorage.getItem('player.volume')) : 1,
        _lastSaveTime: 0, // 记录上次保存到服务器的时间
        
        // DLNA相关状态 - 新增
        playMode: localStorage.getItem('player.playMode') || 'local', // 'local' | 'dlna'
        dlnaDevice: null, // 当前连接的DLNA设备
        dlnaDevices: [], // 可用的DLNA设备列表
        dlnaConnected: false, // DLNA连接状态
        
        // 页面操作相关状态
        homeAction: null, // 当前要执行的home页面操作
        homeActionTimestamp: 0, // 操作触发的时间戳

        // 标签源相关状态
        tagSources: [], // 标签源列表
        tagSourcesLoaded: false, // 标签源是否已加载
        tagSourcesLoading: false, // 标签源是否正在加载
    },
    mutations: {
        setDefaultTableHeight: (state, val) => {
            state.defaultTableHeight = val
        },
        setUserRole: (state, val) => {
            state.userRole = val
        },
        setIsSuperuser: (state, val) => {
            state.isSuperuser = val
        },
        setUsername: (state, val) => {
            state.username = val
        },
        setRemoteVersion: (state, val) => {
            state.remoteVersion = val
        },
        setFullPath: (state, val) => {
            state.fullPath = val
        },
        setHasMsg: (state, val) => {
            state.hasMsg = val
        },
        setPlaying(state) {
            state.isPlaying = true
            if (mediaSession) {
                mediaSession.playbackState = 'playing'
            }
        },
        toggleRepeat(state) {
            state.repeat = !state.repeat
            localStorage.setItem('player.repeat', state.repeat)
        },
        toggleShuffle(state) {
            state.shuffle = !state.shuffle
            localStorage.setItem('player.shuffle', state.shuffle)
        },
        setPaused(state) {
            state.isPlaying = false
            if (mediaSession) {
                mediaSession.playbackState = 'paused'
            }
        },
        setCurrentTime(state, value) {
            state.currentTime = value
            // 每10秒保存一次播放位置到服务器
            if (!state._lastSaveTime || Date.now() - state._lastSaveTime > 15000) {
                state._lastSaveTime = Date.now()
                persistQueue(state, this._vm)
            }
        },
        setDuration(state, value) {
            if (isFinite(value)) {
                state.duration = value
            }
        },
        setStreamTitle(state, value) {
            state.streamTitle = value
        },
        setQueue(state, queue) {
            state.queue = queue
            state.queueIndex = -1
            persistQueue(state, this._vm)
        },
        setQueueIndex(state, index) {
            if (state.queue.length === 0) {
                return
            }
            index = Math.max(0, index)
            index = index < state.queue.length ? index : 0
            state.queueIndex = index
            persistQueue(state, this._vm)
            state.scrobbled = false
            const track = state.queue[index]
            state.duration = track.duration
            
            // DLNA模式下不需要预加载下一首
            if (state.playMode !== 'dlna') {
                const next = (index + 1) % state.queue.length
                audio.setBuffer(state.queue[next].url)
            }
        },
        setQueueIndexInit(state, index) {
            if (state.queue.length === 0) {
                return
            }
            index = Math.max(0, index)
            index = index < state.queue.length ? index : 0
            state.queueIndex = index
            state.scrobbled = false
            const track = state.queue[index]
            state.duration = track.duration
            
            // DLNA模式下不需要预加载下一首
            if (state.playMode !== 'dlna') {
                const next = (index + 1) % state.queue.length
                audio.setBuffer(state.queue[next].url)
            }
        },
        setNextInQueue(state, tracks) {
            state.queue.splice(state.queueIndex + 1, 0, ...tracks)
            persistQueue(state, this._vm)
        },
        addToQueue(state, tracks) {
            state.queue.push(...tracks)
            persistQueue(state, this._vm)
        },
        removeFromQueue(state, index) {
            state.queue.splice(index, 1)
            // 如果当前播放的歌曲索引大于等于要删除的索引
            // 说明删除的是当前播放歌曲之前或当前的歌曲
            // 需要将当前播放索引减1,以保持正确的播放位置
            if (state.queueIndex >= index) {
                state.queueIndex--
            }
            persistQueue(state, this._vm)
        },
        setVolume(state, value) {
            state.volume = value
            localStorage.setItem('player.volume', String(value))
        },
        setCheckedIds(state, value) {
            state.checkedIds = value
        },
        setCheckedData(state, value) {
            state.checkedData = value
        },
        clearQueue(state) {
            // 停止当前播放
            audio.pause()
            state.isPlaying = false
            state.currentTime = 0
            state.duration = 0
            
            // 清空队列
            state.queue = []
            state.queueIndex = -1
            
            // 更新媒体会话状态
            if (mediaSession) {
                mediaSession.playbackState = 'none'
            }
            
            clearQueueApi(state, this._vm)
        },
        shuffleQueue(state) {
            if (state.queue.length > 0) {
                state.queue = shuffled(state.queue, state.queueIndex)
                state.queueIndex = 0
                persistQueue(state, this._vm)
            }
        },
        setSearchTerm(state, term) {
            state.searchTerm = term;
        },
        
        // DLNA相关mutations - 新增
        setPlayMode(state, mode) {
            state.playMode = mode
            localStorage.setItem('player.playMode', mode)
        },
        setDlnaDevice(state, device) {
            state.dlnaDevice = device
            state.dlnaConnected = !!device
        },
        setDlnaDevices(state, devices) {
            state.dlnaDevices = devices
        },
        setDlnaConnected(state, connected) {
            state.dlnaConnected = connected
        },
        
        // ... 保持原有mutations不变 ...
        setSortedField(state, value) {
            state.sortedField = value
            localStorage.setItem('sortedField', JSON.stringify(value))
        },
        setSearchWord(state, value) {
            state.searchWord = value
            localStorage.setItem('searchWord', value)
        },
        
        // 添加页面操作相关的mutation
        triggerHomeAction(state, actionName) {
            // 这个mutation主要用于触发组件间通信
            state.homeAction = actionName
            state.homeActionTimestamp = Date.now()
        },

        // 标签源相关mutations
        setTagSources(state, sources) {
            state.tagSources = sources
            state.tagSourcesLoaded = true
        },
        setTagSourcesLoading(state, loading) {
            state.tagSourcesLoading = loading
        },
        clearTagSources(state) {
            state.tagSources = []
            state.tagSourcesLoaded = false
            state.tagSourcesLoading = false
        }
    },
    actions: {
        async playPause({ state, dispatch }) {
            return state.isPlaying ? dispatch('pause') : dispatch('resume')
        },
        async resume({ commit }) {
            await audio.resume()
            commit('setPlaying')
        },
        setVolume({ commit }, value) {
            commit('setVolume', value)
            audio.setVolume(value)
        },
        async pause({ commit }) {
            await audio.pause()
            commit('setPaused')
        },
        toggleRepeat({ commit }) {
            commit('toggleRepeat')
        },
        toggleShuffle({ commit }) {
            commit('toggleShuffle')
        },
        seek({ state }, value) {
            // DLNA模式下使用DLNA seek
            if (state.playMode === 'dlna' && state.dlnaConnected) {
                return audio.dlnaSeek(value * state.duration)
            }
            // 本地播放模式
            audio.seek(value)
        },
        
        // 专门的DLNA seek action，支持绝对时间跳转
        async dlnaSeekTo({ state, commit }, timeInSeconds) {
            if (state.playMode !== 'dlna' || !state.dlnaConnected) {
                throw new Error('当前不是DLNA模式或未连接DLNA设备')
            }
            
            try {
                const success = await audio.dlnaSeek(timeInSeconds)
                if (success) {
                    // 更新本地状态
                    commit('setCurrentTime', timeInSeconds)
                }
                return success
            } catch (error) {
                console.error('DLNA跳转失败:', error)
                throw error
            }
        },
        
        // DLNA相关actions - 新增
        async discoverDlnaDevices({ commit }, refresh = false) {
            try {
                const result = await this._vm.$api.dlna.discoverDevices({ refresh })
                if (result.data && result.data.devices) {
                    let allDevices = [...result.data.devices]
                    
                    // 加载本地存储的手动添加设备
                    const manualDevices = this.getters.getManualDlnaDevices
                    if (manualDevices && manualDevices.length > 0) {
                        // 合并自动发现的设备和手动添加的设备，避免重复
                        const existingUdns = allDevices.map(d => d.udn)
                        const validManualDevices = manualDevices.filter(d => !existingUdns.includes(d.udn))
                        allDevices = [...allDevices, ...validManualDevices]
                    }
                    
                    commit('setDlnaDevices', allDevices)
                    
                    // 如果有之前选中的设备，尝试恢复连接
                    if (result.data.selected_device_id) {
                        const selectedDevice = allDevices.find(d => d.udn === result.data.selected_device_id)
                        if (selectedDevice) {
                            commit('setDlnaDevice', selectedDevice)
                            commit('setPlayMode', 'dlna')
                            audio.setPlayMode('dlna', selectedDevice)
                        }
                    }
                }
                return result
            } catch (error) {
                console.error('发现DLNA设备失败:', error)
                throw error
            }
        },
        
        async connectToDlnaDevice({ commit, state }, device) {
            try {
                const result = await this._vm.$api.dlna.connect(device.udn)
                if (result.success) {
                    commit('setDlnaDevice', device)
                    commit('setPlayMode', 'dlna')
                    
                    // 通知AudioController切换模式
                    audio.setPlayMode('dlna', device)
                    
                    // 如果当前有播放音乐，推送到DLNA设备
                    if (state.queue.length > 0 && state.queueIndex >= 0) {
                        const currentTrack = state.queue[state.queueIndex]

                        await audio.changeTrack({
                            ...currentTrack,
                            currentTime: state.currentTime,
                            paused: !state.isPlaying
                        })
                    }
                }
                return result
            } catch (error) {
                console.error('连接DLNA设备失败:', error)
                throw error
            }
        },
        
        async disconnectFromDlnaDevice({ commit }) {
            try {
                const result = await this._vm.$api.dlna.disconnect()
                if (result.success) {
                    commit('setDlnaDevice', null)
                    commit('setPlayMode', 'local')
                    
                    // 通知AudioController切换模式
                    audio.setPlayMode('local')
                }
                return result
            } catch (error) {
                console.error('断开DLNA连接失败:', error)
                throw error
            }
        },
        
        async switchToLocalPlay({ commit, state }) {
            try {
                // 先断开DLNA连接
                await this.dispatch('disconnectFromDlnaDevice')
                
                // 如果当前有播放音乐，继续在本地播放
                if (state.queue.length > 0 && state.queueIndex >= 0) {
                    const currentTrack = state.queue[state.queueIndex]
                    await audio.changeTrack({
                        ...currentTrack,
                        currentTime: state.currentTime,
                        paused: !state.isPlaying
                    })
                }
            } catch (error) {
                console.error('切换到本地播放失败:', error)
                throw error
            }
        },

        /**
         * 手动添加DLNA设备到设备列表
         * @param {Object} context Vuex上下文
         * @param {Object} device 设备信息对象
         */
        async addManualDlnaDevice({ commit, state }, device) {
            try {
                // 验证设备信息
                if (!device.udn || !device.device_info?.name) {
                    throw new Error('设备信息不完整，必须包含UDN和设备名称')
                }

                // 检查设备是否已存在
                const existingDevice = state.dlnaDevices.find(d => d.udn === device.udn)
                if (existingDevice) {
                    throw new Error('该设备已存在，无法重复添加')
                }

                // 获取当前设备列表
                const currentDevices = [...state.dlnaDevices]
                
                // 添加新设备到列表
                currentDevices.push(device)
                
                // 更新store中的设备列表
                commit('setDlnaDevices', currentDevices)
                
                // 保存手动添加的设备到本地存储
                this.dispatch('saveManualDlnaDevices')
                
                // TODO: 如果后端支持，可以调用API保存手动添加的设备
                // await this._vm.$api.dlna.addManualDevice(device)
                
                console.log('手动添加DLNA设备成功:', device)
                return { success: true, device }
            } catch (error) {
                console.error('手动添加DLNA设备失败:', error)
                throw error
            }
        },

        /**
         * 移除手动添加的DLNA设备
         * @param {Object} context Vuex上下文  
         * @param {string} deviceUdn 设备UDN
         */
        async removeManualDlnaDevice({ commit, state }, deviceUdn) {
            try {
                // 获取当前设备列表
                const currentDevices = [...state.dlnaDevices]
                
                // 找到要移除的设备
                const deviceIndex = currentDevices.findIndex(d => d.udn === deviceUdn)
                if (deviceIndex === -1) {
                    throw new Error('未找到指定的设备')
                }

                const deviceToRemove = currentDevices[deviceIndex]
                
                // 检查是否为手动添加的设备
                if (!deviceToRemove.isManual) {
                    throw new Error('只能移除手动添加的设备')
                }

                // 如果当前连接的是这个设备，先断开连接
                if (state.dlnaDevice && state.dlnaDevice.udn === deviceUdn) {
                    await this.dispatch('disconnectFromDlnaDevice')
                }
                
                // 从列表中移除设备
                currentDevices.splice(deviceIndex, 1)
                
                // 更新store中的设备列表
                commit('setDlnaDevices', currentDevices)
                
                // 更新本地存储
                this.dispatch('saveManualDlnaDevices')
                
                // TODO: 如果后端支持，可以调用API删除保存的设备
                // await this._vm.$api.dlna.removeManualDevice(deviceUdn)
                
                console.log('移除手动添加的DLNA设备成功:', deviceUdn)
                return { success: true }
            } catch (error) {
                console.error('移除手动添加的DLNA设备失败:', error)
                throw error
                        }
        },

        /**
         * 保存手动添加的设备到本地存储
         * @param {Object} context Vuex上下文
         */
        saveManualDlnaDevices({ state }) {
            try {
                // 筛选出手动添加的设备
                const manualDevices = state.dlnaDevices.filter(device => device.isManual)
                
                // 保存到localStorage
                localStorage.setItem('manual_dlna_devices', JSON.stringify(manualDevices))
                
                console.log('手动添加的DLNA设备已保存到本地存储:', manualDevices.length, '个设备')
            } catch (error) {
                console.error('保存手动DLNA设备到本地存储失败:', error)
            }
        },

        /**
         * 从本地存储加载手动添加的设备
         * @param {Object} context Vuex上下文
         */
        loadManualDlnaDevices({ commit, state }) {
            try {
                const saved = localStorage.getItem('manual_dlna_devices')
                if (saved) {
                    const manualDevices = JSON.parse(saved)
                    
                    // 合并到当前设备列表
                    const currentDevices = [...state.dlnaDevices]
                    const existingUdns = currentDevices.map(d => d.udn)
                    
                    // 添加不重复的手动设备
                    const newDevices = manualDevices.filter(device => 
                        device.isManual && !existingUdns.includes(device.udn)
                    )
                    
                    if (newDevices.length > 0) {
                        commit('setDlnaDevices', [...currentDevices, ...newDevices])
                        console.log('从本地存储加载手动DLNA设备:', newDevices.length, '个设备')
                    }
                }
            } catch (error) {
                console.error('从本地存储加载手动DLNA设备失败:', error)
            }
        },
         
        // 原有actions保持不变，但需要考虑DLNA模式
        async next({ commit, state, getters }) {
            // 随机播放模式下，总是可以播放下一首；非随机模式下才检查hasNext和repeat
            if (!state.shuffle && !getters.hasNext && !state.repeat) {
                return
            }
            
            let index
            if (state.shuffle) {
                // 随机播放模式：在action中直接生成随机索引，避免getter缓存问题
                if (state.queue.length <= 1) {
                    // 队列只有一首歌或为空，直接使用当前索引
                    index = state.queueIndex
                } else {
                    // 生成一个与当前播放歌曲不同的随机索引
                    do {
                        index = Math.floor(Math.random() * state.queue.length)
                    } while (index === state.queueIndex)
                }
                console.log('随机生成索引:', index, '(避免重复当前:', state.queueIndex, ')')
            } else {
                // 顺序播放模式：使用getter
                index = getters.nextIndex
                console.log('顺序播放索引:', index)
            }
            
            commit('setQueueIndex', index)
            const track = state.queue[index]
            if (track) {
                await audio.changeTrack(track)
                commit('setPlaying')
            }
        },
        async previous({ commit, state, getters }) {
            // 随机播放模式下，总是可以播放上一首；非随机模式下才检查hasPrevious和repeat
            if (!state.shuffle && !getters.hasPrevious && !state.repeat) {
                return
            }
            
            let index
            if (state.shuffle) {
                // 随机播放模式：在action中直接生成随机索引，避免getter缓存问题
                if (state.queue.length <= 1) {
                    // 队列只有一首歌或为空，直接使用当前索引
                    index = state.queueIndex
                } else {
                    // 生成一个与当前播放歌曲不同的随机索引
                    do {
                        index = Math.floor(Math.random() * state.queue.length)
                    } while (index === state.queueIndex)
                }
            } else {
                // 顺序播放模式：使用getter
                index = getters.previousIndex
            }
            
            commit('setQueueIndex', index)
            const track = state.queue[index]
            if (track) {
                await audio.changeTrack(track)
                commit('setPlaying')
            }
        },
        async resetQueue({ commit, getters }) {
            commit('setQueueIndex', 0)
            commit('setPaused')
            const track = getters.track
            await audio.changeTrack({
                ...track,
                title: track.title || '未知歌曲',
                artist: track.artist || '未知艺术家',
                album: track.album || '未知专辑',
                artwork: track.image,
                paused: true
            })
        },
        async playTrackList({ commit, state, getters }, { tracks, index }) {
            if (index === null) {
                index = state.shuffle ? Math.floor(Math.random() * tracks.length) : 0
            }
            if (state.shuffle) {
                tracks = [...tracks]
                shuffle(tracks, index)
                index = 0
            }
            if (!trackListEquals(state.queue, tracks)) {
                commit('setQueue', tracks)
            }
            commit('setQueueIndex', index)
            commit('setPlaying')
            const track = getters.track
            await audio.changeTrack({
                ...track,
                title: track.title,
                artist: track.artist,
                album: track.album,
                artwork: track.image
            })
        },
        
        // 加载播放队列时考虑DLNA模式
        async loadPlayQueue({ commit, state, getters }) {
            try {
                // 使用统一的API接口
                const playQueue = await this._vm.$api.subsonic.getPlayQueue()
                if (playQueue && playQueue.tracks && playQueue.tracks.length > 0) {
                    const tracks = playQueue.tracks
                    const currentTrackId = playQueue.current
                    const position = playQueue.position || 0

                    // 设置播放队列
                    state.queue = tracks
                    state.queueIndex = -1
                    // 找到当前播放歌曲的索引
                    if (currentTrackId) {
                        const currentIndex = tracks.findIndex(track => track.id == currentTrackId)
                        if (currentIndex >= 0) {
                            commit('setQueueIndexInit', currentIndex)
                            
                            // 获取当前歌曲信息
                            const track = getters.track
                            
                            // 恢复播放歌曲（但保持暂停状态）
                            // 新的changeTrack方法已经优化了paused模式的处理
                            await audio.changeTrack({
                                ...track,
                                title: track.title || track.name,
                                artist: track.artist || track.artistName,
                                album: track.album || track.albumName,
                                artwork: track.image || track.artwork || track.coverArt,
                                paused: true // 恢复时保持暂停状态
                            })
                            state.currentTime = position
                            // 等待音频加载完成后再seek
                            await new Promise((resolve) => {
                                const checkCanSeek = () => {
                                    if (audio.duration() > 0) {
                                        resolve()
                                    } else {
                                        setTimeout(checkCanSeek, 100)
                                    }
                                }
                                checkCanSeek()
                            })
                            console.log('position', position)
                            // seek到保存的位置
                            if (position > 0) {
                                console.log('seek to', position)
                                audio.seek(position, 's')
                            }
                            
                            return true
                        }
                    }
                }
                
                return false
                
            } catch (error) {
                console.warn('加载播放队列失败:', error.message)    
                return false
            }
        },
         // 初始化播放器状态（在应用启动时调用）
         async initializePlayer({ dispatch, commit }) {

            // 加载播放队列
            await dispatch('loadPlayQueue')
        },

        // 加载标签源列表（带缓存）
        async loadTagSources({ state, commit }, { force = false } = {}) {
            // 如果已经加载过且不是强制刷新，直接返回缓存数据
            if (state.tagSourcesLoaded && !force) {
                return state.tagSources
            }

            // 如果正在加载中，等待加载完成
            if (state.tagSourcesLoading) {
                return new Promise((resolve) => {
                    const checkLoaded = () => {
                        if (!state.tagSourcesLoading) {
                            resolve(state.tagSources)
                        } else {
                            setTimeout(checkLoaded, 100)
                        }
                    }
                    checkLoaded()
                })
            }

            // 开始加载
            commit('setTagSourcesLoading', true)

            try {
                const res = await this._vm.$api.scriptMgmt.getTagSources({
                    page_size: 99,
                    status: 'active'
                })

                let sources = []
                if (res.result && res.data && res.data.items) {
                    // 将插件数据转换为前端需要的格式
                    sources = res.data.items.map(plugin => ({
                        id: plugin.unique_id,
                        name: plugin.display_name
                    }))
                } else {
                    // 如果获取失败，使用默认的标签源列表
                    sources = [
                        { id: 'netease', name: '网易云音乐' },
                        { id: 'migu', name: '咪咕音乐' },
                        { id: 'qmusic', name: 'QQ音乐' },
                        { id: 'kugou', name: '酷狗音乐' },
                        { id: 'kuwo', name: '酷我音乐' },
                        { id: 'itunes', name: 'iTunes' },
                        { id: 'spotify', name: 'Spotify' },
                        { id: 'musicbrainz', name: 'MusicBrainz' },
                        { id: 'acoustid', name: '声纹识别' },
                        { id: 'smart_tag', name: '智能刮削' }
                    ]
                }

                commit('setTagSources', sources)
                return sources
            } catch (error) {
                console.error('加载标签源失败:', error)

                // 请求出错时使用默认列表
                const defaultSources = [
                    { id: 'netease', name: '网易云音乐' },
                    { id: 'migu', name: '咪咕音乐' },
                    { id: 'qmusic', name: 'QQ音乐' },
                    { id: 'kugou', name: '酷狗音乐' },
                    { id: 'kuwo', name: '酷我音乐' },
                    { id: 'itunes', name: 'iTunes' },
                    { id: 'spotify', name: 'Spotify' },
                    { id: 'musicbrainz', name: 'MusicBrainz' },
                    { id: 'acoustid', name: '声纹识别' },
                    { id: 'smart_tag', name: '智能刮削' }
                ]

                commit('setTagSources', defaultSources)
                return defaultSources
            } finally {
                commit('setTagSourcesLoading', false)
            }
        }
    },
    
    // 保持原有getters不变
    getters: {
        hasNext: state => state.queueIndex + 1 < state.queue.length,
        hasPrevious: state => state.queueIndex - 1 >= 0,
        nextIndex: (state, getters) => {
            // 只处理顺序播放的情况，随机播放逻辑已移到action中
            const nextIndex = state.queueIndex + 1
            return nextIndex < state.queue.length ? nextIndex : 0
        },
        previousIndex: (state, getters) => {
            // 只处理顺序播放的情况，随机播放逻辑已移到action中
            const prevIndex = state.queueIndex - 1
            return prevIndex >= 0 ? prevIndex : state.queue.length - 1
        },
        
        // 获取当前播放音轨
        track: state => {
            if (state.queue.length > 0 && state.queueIndex >= 0 && state.queueIndex < state.queue.length) {
                return state.queue[state.queueIndex]
            }
            return null
        },
        
        // 新增DLNA相关getters
        isDlnaMode: state => state.playMode === 'dlna',
        isDlnaConnected: state => state.dlnaConnected && state.dlnaDevice,
        currentDlnaDevice: state => state.dlnaDevice,
        availableDlnaDevices: state => state.dlnaDevices,
        
        // 检查是否可以进行DLNA seek操作
        canDlnaSeek: state => state.playMode === 'dlna' && state.dlnaConnected && state.dlnaDevice,
        
        // 获取手动添加的设备列表
        manualDlnaDevices: state => state.dlnaDevices.filter(device => device.isManual),
        
        // 获取本地存储的手动设备
        getManualDlnaDevices: () => {
            try {
                const saved = localStorage.getItem('manual_dlna_devices')
                return saved ? JSON.parse(saved) : []
            } catch (error) {
                console.error('获取本地存储的手动DLNA设备失败:', error)
                return []
            }
        },

        // 标签源相关getters
        tagSources: state => state.tagSources,
        tagSourcesLoaded: state => state.tagSourcesLoaded,
        tagSourcesLoading: state => state.tagSourcesLoading
    }
}

export default common
